import Card from '@mui/material/Card';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React from 'react';
import CardText from 'react/shared/components/true_link/main/form/wizard/CardText';
import theme from 'react/shared/theme/Theme';
import SignUpTextList from 'react/signups/card/common/SignUpTextList';

const useStyles = makeStyles(() => ({
  captionTitle: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
  },
  cardSubject: {
    textAlign: 'center',
    paddingBottom: theme.spacing(2),
  },
  img: {
    height: '170px',
  },
  listItems: {
    display: 'flex',
    justifyContent: 'center',
  },
  unorderedList: {
    maxWidth: '360px',
  },
  card: {
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderRadius: theme.shape.borderRadius,
    boxShadow: '0 4px 14px 0 #00000010',
    height: '97%',
    padding: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      border: '1px solid rgba(0, 0, 0, 0.1)',
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(8),
    },
  },
  wrap: {
    height: '100%',
  },
}));

export default function BrandMomentCard({ cardCaption, cardCopy, cardListItems, imgAlt, imgSrc }) {
  const classes = useStyles();

  return (
    <div className={classes.wrap}>
      <Card className={classes.card}>
        <div className={classes.cardSubject}>
          <img alt={imgAlt} className={classes.img} src={imgSrc} />
          <CardText className={classes.captionTitle}>{cardCaption}</CardText>
          <CardText>{cardCopy}</CardText>
        </div>
        <div className={classes.listItems}>
          <SignUpTextList className={classes.unorderedList} listItems={cardListItems} />
        </div>
      </Card>
    </div>
  );
}

BrandMomentCard.propTypes = {
  cardCaption: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  cardCopy: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  cardListItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  imgAlt: PropTypes.string.isRequired,
  imgSrc: PropTypes.string.isRequired,
};
